import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaInstagram, FaFacebook } from 'react-icons/fa';
import ziplogyxLogo from '../assets/images/Labh Logo.png';
import texture from '../assets/images/background-image.jpg';

const socialLinks = [
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/labhindustires/', Icon: FaLinkedin },
  { name: 'Instagram', href: 'https://www.instagram.com/labhindustry', Icon: FaInstagram },
  { name: 'Facebook', href: 'https://www.facebook.com/labhindustry', Icon: FaFacebook },
];

export const Footer = () => {
  return (
    <motion.footer
      className="relative w-full py-12 px-4 sm:px-6 md:px-8 lg:px-16"
      style={{
        backgroundImage: `url(${texture})`,
        backgroundColor: "#93A7AA",
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    >
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12">

        {/* Top Section */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-12 w-full">

          {/* Logo */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }} 
            whileInView={{ opacity: 1, scale: 1 }} 
            transition={{ duration: 0.5 }}
            className="flex justify-center md:justify-start md:w-1/3"
          >
            <img 
              className="h-20 w-auto object-contain" 
              src={ziplogyxLogo} 
              alt="Ziplogyx Logo" 
              loading="lazy"
            />
          </motion.div>

          {/* Quick Links */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.6 }}
            className="flex flex-col gap-4 md:w-1/3"
          >
            <h3 className="text-white font-roboto font-medium text-lg uppercase">
              Quick Links
            </h3>
            <div className="flex flex-col gap-3">
              {['Home', 'Services', 'About', 'Contact'].map((link, i) => (
                <a
                  key={i}
                  href={`/${link.toLowerCase()}`}
                  className="text-[#e0e0e0] text-base hover:text-white hover:scale-105 transition duration-300"
                >
                  {link}
                </a>
              ))}
            </div>
          </motion.div>

          {/* Contact Info */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex flex-col gap-4 md:w-1/3"
          >
            <h3 className="text-white font-roboto font-medium text-lg uppercase">
              Contact Info
            </h3>
            <div className="flex flex-col gap-3 text-[#e0e0e0] text-base">
              <a href="tel:+919909501696" className="hover:text-white transition duration-300">+91 99095 01696</a>
              <a href="mailto:amp@labhind.com" className="hover:text-white transition duration-300">amp@labhind.com</a>
              <p>
                Plot 221, Navi Jambuvai,<br />
                Near Ajwa Canal-Nimeta Village,<br />
                Taluka - Waghodia, Vadodara – 391760
              </p>
            </div>
          </motion.div>
        </div>

        {/* Divider */}
        <motion.hr 
          className="border-t-2 border-[#d69291] w-full"
          initial={{ width: 0 }}
          whileInView={{ width: "100%" }}
          transition={{ duration: 1 }}
        />

        {/* Bottom Section */}
        <motion.div 
          className="flex flex-col md:flex-row justify-between items-center gap-6 w-full"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <p className="text-[#e0e0e0] text-sm md:text-base text-center md:text-left">
            All Copyrights Reserved @2024 Labh Industries
          </p>

          {/* Social Media Icons */}
          <div className="flex gap-4">
            {socialLinks.map(({ name, href, Icon }) => (
              <a
                key={name}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={name}
                className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white hover:bg-white/20 hover:scale-110 transition duration-300"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};
